/**
 * Kolaportið — Booking Flow
 * Vanilla JS, no dependencies
 */
(function () {
  'use strict';

  // ─── Data ──────────────────────────────────────────────────────────────────

  const WEEKENDS = [
    { id: 'w1', en: 'Sat–Sun · 21–22 Jun', is: 'Lau–Sun · 21.–22. jún', cap: 15, booked: 9 },
    { id: 'w2', en: 'Sat–Sun · 28–29 Jun', is: 'Lau–Sun · 28.–29. jún', cap: 15, booked: 15 },
    { id: 'w3', en: 'Sat–Sun · 5–6 Jul',   is: 'Lau–Sun · 5.–6. júl',  cap: 15, booked: 6 },
    { id: 'w4', en: 'Sat–Sun · 12–13 Jul', is: 'Lau–Sun · 12.–13. júl', cap: 15, booked: 13 },
    { id: 'xmas', en: 'Christmas Market · 13–14 Dec', is: 'Jólamarkaður · 13.–14. des', cap: 50, booked: 31, special: true },
  ];

  const PRICES = { weekend: 11900, day: 6900, xWeekend: 14900, xDay: 8900 };

  // ─── State ─────────────────────────────────────────────────────────────────

  const state = {
    step: 'select',       // select | details | review | confirm | waitlist | waitlist-done
    bookingType: 'weekend', // weekend | day
    cart: [],             // array of weekend IDs
    waitlistId: null,
    form: { name: '', business: '', email: '', phone: '', category: '', desc: '', terms: false, photos: [] },
    wl: { name: '', email: '', phone: '', product: '', msg: '' },
    orderNum: 4000 + Math.floor(Math.random() * 1000),
  };

  // ─── Helpers ───────────────────────────────────────────────────────────────

  function getLang() {
    return (window.KP_LOCALE || document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  }

  function label(w) {
    return getLang() === 'is' ? w.is : w.en;
  }

  function isk(n) {
    return n.toLocaleString('de-DE') + ' kr.';
  }

  function priceFor(w) {
    if (w.special) return state.bookingType === 'weekend' ? PRICES.xWeekend : PRICES.xDay;
    return state.bookingType === 'weekend' ? PRICES.weekend : PRICES.day;
  }

  function isSoldOut(w) {
    return (w.cap - w.booked) <= 0;
  }

  function pct(w) {
    return Math.min(100, Math.round((w.booked / w.cap) * 100));
  }

  function badgeClass(w) {
    if (w.special) return 'kp-badge kp-badge--special';
    const left = w.cap - w.booked;
    if (left <= 0) return 'kp-badge kp-badge--waitlist';
    if (left <= 4) return 'kp-badge kp-badge--almost';
    return 'kp-badge kp-badge--open';
  }

  function badgeLabel(w) {
    const lang = getLang();
    if (w.special) return lang === 'is' ? 'Sérmarkaður' : 'Special';
    const left = w.cap - w.booked;
    if (left <= 0) return lang === 'is' ? 'Biðlisti' : 'Waitlist';
    if (left <= 4) return lang === 'is' ? 'Að fyllast' : 'Almost full';
    return lang === 'is' ? 'Laust' : 'Open';
  }

  function capLabel(w) {
    const lang = getLang();
    const left = w.cap - w.booked;
    if (left <= 0) return lang === 'is' ? 'Fullbókað' : 'Sold out';
    return lang === 'is'
      ? `${left} básar eftir af ${w.cap}`
      : `${left} of ${w.cap} booths left`;
  }

  function fromLabel(w) {
    const lang = getLang();
    const base = w.special ? PRICES.xDay : PRICES.day;
    return (lang === 'is' ? 'frá ' : 'from ') + isk(base);
  }

  function cartTotal() {
    return state.cart.reduce(function (sum, id) {
      const w = WEEKENDS.find(function (x) { return x.id === id; });
      return sum + (w ? priceFor(w) : 0);
    }, 0);
  }

  function q(id) { return document.getElementById(id); }

  function el(tag, cls, html) {
    const e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html !== undefined) e.innerHTML = html;
    return e;
  }

  // ─── Render: Home weekend cards ────────────────────────────────────────────

  function renderHomeWeekends() {
    const container = q('kp-home-weekends');
    if (!container) return;
    container.innerHTML = '';
    const lang = getLang();
    const bookUrl = window.KP_BOOK_URL || '/pages/book-a-booth';

    WEEKENDS.forEach(function (w) {
      const soldOut = isSoldOut(w);
      const card = el('div', 'kp-weekend-card');

      const top = el('div', 'kp-weekend-card__top');
      const badge = el('span', badgeClass(w), badgeLabel(w));
      const price = el('span', 'kp-weekend-card__price', fromLabel(w));
      top.appendChild(badge);
      top.appendChild(price);

      const dateEl = el('h3', 'kp-weekend-card__date', label(w));

      const barWrap = el('div');
      const bar = el('div', 'kp-availability-bar');
      const fill = el('div', 'kp-availability-bar__fill' + (soldOut ? ' kp-availability-bar__fill--sold' : ''));
      fill.style.width = pct(w) + '%';
      bar.appendChild(fill);
      const capEl = el('div', 'kp-availability-label', capLabel(w));
      barWrap.appendChild(bar);
      barWrap.appendChild(capEl);

      const btnLabel = soldOut
        ? (lang === 'is' ? 'Á biðlista' : 'Join waitlist')
        : (lang === 'is' ? 'Bóka bás' : 'Book a Booth');

      const btn = el('a', 'kp-btn kp-btn--full' + (soldOut ? ' kp-btn--ghost-outline' : ' kp-btn--dark'), btnLabel);
      var variantId = window.KP_VARIANTS && window.KP_VARIANTS[w.type || 'full_weekend'];
      btn.href = bookUrl + (variantId ? '?variant=' + variantId : '') + '&weekend=' + w.id;
      btn.style.textAlign = 'center';

      card.appendChild(top);
      card.appendChild(dateEl);
      card.appendChild(barWrap);
      card.appendChild(btn);
      container.appendChild(card);
    });
  }

  // ─── Render: Weekend rows (booking page) ───────────────────────────────────

  function renderWeekendList() {
    const container = q('kp-weekend-list');
    if (!container) return;
    container.innerHTML = '';
    const lang = getLang();

    WEEKENDS.forEach(function (w) {
      const soldOut = isSoldOut(w);
      const inCart = state.cart.includes(w.id);

      const row = el('div', 'kp-weekend-row' + (inCart ? ' is-selected' : ''));
      row.dataset.weekendId = w.id;

      const info = el('div', 'kp-weekend-row__info');
      const dateRow = el('div', 'kp-weekend-row__date');
      const dateText = document.createTextNode(label(w) + ' ');
      const badge = el('span', badgeClass(w), badgeLabel(w));
      dateRow.appendChild(dateText);
      dateRow.appendChild(badge);

      const meta = el('div', 'kp-weekend-row__meta', capLabel(w) + ' · ' + fromLabel(w));
      info.appendChild(dateRow);
      info.appendChild(meta);

      let btnLabel, btnClass;
      if (soldOut) {
        btnLabel = lang === 'is' ? 'Biðlisti' : 'Waitlist';
        btnClass = 'kp-select-btn kp-select-btn--waitlist';
      } else if (inCart) {
        btnLabel = lang === 'is' ? 'Valið ✓' : 'Selected ✓';
        btnClass = 'kp-select-btn kp-select-btn--selected';
      } else {
        btnLabel = lang === 'is' ? 'Velja' : 'Select';
        btnClass = 'kp-select-btn';
      }

      const btn = el('button', btnClass, btnLabel);
      btn.type = 'button';
      btn.dataset.action = soldOut ? 'open-waitlist' : 'toggle-weekend';
      btn.dataset.weekendId = w.id;

      row.appendChild(info);
      row.appendChild(btn);
      container.appendChild(row);
    });
  }

  // ─── Render: Cart ──────────────────────────────────────────────────────────

  function renderCart() {
    const emptyEl = q('kp-cart-empty');
    const itemsEl = q('kp-cart-items');
    const listEl  = q('kp-cart-list');
    const totalEl = q('kp-cart-total-label');
    const btn     = q('kp-continue-btn');
    if (!emptyEl || !itemsEl || !listEl) return;

    if (state.cart.length === 0) {
      emptyEl.style.display = '';
      itemsEl.style.display = 'none';
      if (btn) { btn.classList.remove('is-ready'); }
      return;
    }

    emptyEl.style.display = 'none';
    itemsEl.style.display = '';
    if (btn) { btn.classList.add('is-ready'); }

    listEl.innerHTML = '';
    const lang = getLang();

    state.cart.forEach(function (id) {
      const w = WEEKENDS.find(function (x) { return x.id === id; });
      if (!w) return;
      const price = priceFor(w);
      const typeLabel = state.bookingType === 'weekend'
        ? (lang === 'is' ? 'Heil helgi' : 'Full weekend')
        : (lang === 'is' ? 'Stakur dagur' : 'Single day');

      const item = el('div', 'kp-cart-item');
      const left = el('div');
      left.innerHTML = '<div class="kp-cart-item__name">' + label(w) + '</div>' +
        '<div class="kp-cart-item__sub">' + typeLabel + '</div>';
      const right = el('div', null);
      right.style.cssText = 'display:flex;align-items:center;gap:8px;';
      const priceEl = el('span', 'kp-cart-item__price', isk(price));
      const removeBtn = el('button', 'kp-cart-item__remove', '✕');
      removeBtn.type = 'button';
      removeBtn.dataset.action = 'remove-from-cart';
      removeBtn.dataset.weekendId = id;
      removeBtn.setAttribute('aria-label', 'Remove ' + label(w));
      right.appendChild(priceEl);
      right.appendChild(removeBtn);
      item.appendChild(left);
      item.appendChild(right);
      listEl.appendChild(item);
    });

    if (totalEl) totalEl.textContent = isk(cartTotal());
  }

  // ─── Render: Review step ───────────────────────────────────────────────────

  function renderReview() {
    const lang = getLang();
    const f = state.form;

    const biz = q('kp-review-business');
    if (biz) biz.textContent = f.business;

    const meta = q('kp-review-meta');
    if (meta) meta.textContent = f.name + ' · ' + f.email + ' · ' + f.phone;

    const desc = q('kp-review-desc');
    if (desc) {
      const catEl = el('strong', null, f.category);
      desc.innerHTML = '';
      desc.appendChild(catEl);
      desc.appendChild(document.createTextNode(' — ' + f.desc));
    }

    const photos = q('kp-review-photos');
    if (photos) {
      const count = f.photos.length;
      photos.textContent = lang === 'is'
        ? count + ' mynd(ir) hlaðið upp'
        : count + ' photo(s) uploaded';
    }

    const boothsEl = q('kp-review-booths');
    if (boothsEl) {
      boothsEl.innerHTML = '';
      const typeLabel = state.bookingType === 'weekend'
        ? (lang === 'is' ? 'Heil helgi' : 'Full weekend')
        : (lang === 'is' ? 'Stakur dagur' : 'Single day');
      state.cart.forEach(function (id) {
        const w = WEEKENDS.find(function (x) { return x.id === id; });
        if (!w) return;
        const row = el('div', 'kp-review-booth-row');
        row.innerHTML = '<div><div style="font-weight:600;color:var(--ink)">' + label(w) + '</div>' +
          '<div style="font-size:12px;color:var(--muted)">' + typeLabel + '</div></div>' +
          '<span style="font-weight:700;color:var(--ink)">' + isk(priceFor(w)) + '</span>';
        boothsEl.appendChild(row);
      });
    }

    const total = isk(cartTotal());
    const sub = q('kp-review-subtotal');
    const tot = q('kp-review-total');
    if (sub) sub.textContent = total;
    if (tot) tot.textContent = total;
  }

  // ─── Step navigation ───────────────────────────────────────────────────────

  const STEPS = ['select', 'details', 'review', 'confirm', 'waitlist', 'waitlist-done'];

  function showStep(name) {
    STEPS.forEach(function (s) {
      var elId = 'kp-step-' + s;
      const stepEl = document.getElementById(elId);
      if (stepEl) stepEl.style.display = s === name ? '' : 'none';
    });

    // Update pills
    const pillMap = { select: 1, details: 2, review: 3, confirm: 3 };
    const activePill = pillMap[name] || 1;
    const pills = document.querySelectorAll('.kp-step-pill[data-pill]');
    pills.forEach(function (pill) {
      const n = parseInt(pill.dataset.pill, 10);
      pill.classList.toggle('is-active', n === activePill);
      pill.classList.toggle('is-done', n < activePill);
    });

    state.step = name;

    // Scroll to top of booking section
    const hero = document.querySelector('.kp-book-hero');
    if (hero) {
      const top = hero.getBoundingClientRect().top + window.pageYOffset - 70;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }

  // ─── Actions ───────────────────────────────────────────────────────────────

  function toggleWeekend(id) {
    const idx = state.cart.indexOf(id);
    if (idx === -1) state.cart.push(id);
    else state.cart.splice(idx, 1);
    renderWeekendList();
    renderCart();
  }

  function removeFromCart(id) {
    state.cart = state.cart.filter(function (x) { return x !== id; });
    renderWeekendList();
    renderCart();
  }

  function openWaitlist(id) {
    state.waitlistId = id;
    const w = WEEKENDS.find(function (x) { return x.id === id; });
    const dateEl = q('kp-wl-date');
    if (dateEl && w) dateEl.textContent = label(w);
    showStep('waitlist');
  }

  function toDetails() {
    if (state.cart.length === 0) return;
    showStep('details');
  }

  function validateForm() {
    const f = state.form;
    return f.name.trim() && f.business.trim() && f.email.trim() &&
           f.phone.trim() && f.category && f.desc.trim() &&
           f.terms && f.photos.length > 0;
  }

  function toReview() {
    // Read form values
    const fields = ['name', 'business', 'email', 'phone', 'desc'];
    fields.forEach(function (k) {
      const inp = q('kp-f-' + k);
      if (inp) state.form[k] = inp.value;
    });
    const cat = q('kp-f-category');
    if (cat) state.form.category = cat.options[cat.selectedIndex] ? cat.options[cat.selectedIndex].text : cat.value;
    const terms = q('kp-f-terms');
    if (terms) state.form.terms = terms.checked;

    if (!validateForm()) {
      const hint = q('kp-form-hint');
      if (hint) hint.style.display = '';
      return;
    }

    const hint = q('kp-form-hint');
    if (hint) hint.style.display = 'none';
    renderReview();
    showStep('review');
  }

  function payNow() {
    const btn = q('kp-pay-btn');
    if (btn) { btn.disabled = true; btn.textContent = '…'; }

    // Build Shopify cart items
    const items = state.cart.map(function (id) {
      const w = WEEKENDS.find(function (x) { return x.id === id; });
      const price = priceFor(w);
      // Shopify Cart API expects variant ID; use a placeholder product variant
      // In production, replace 0 with the actual Shopify booth product variant ID
      return {
        id: 0, // placeholder — set to real variant ID
        quantity: 1,
        properties: {
          Weekend: label(w),
          Type: state.bookingType,
          Vendor: state.form.business,
          Contact: state.form.email,
          _price_isk: price,
        }
      };
    });

    // Try Shopify Cart API, fall back to confirm screen
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) {
        if (r.ok) {
          window.location.href = '/checkout';
        } else {
          // No real product set up yet — show confirmation screen for demo
          confirmBooking();
        }
      })
      .catch(function () {
        // Network error or no product — show confirmation screen
        confirmBooking();
      });
  }

  function confirmBooking() {
    state.orderNum += 1;
    const numEl = q('kp-order-num');
    if (numEl) numEl.textContent = state.orderNum;
    showStep('confirm');
  }

  function joinWaitlist() {
    const nameEl  = q('kp-wl-name');
    const emailEl = q('kp-wl-email');
    const phoneEl = q('kp-wl-phone');

    const name  = nameEl  ? nameEl.value.trim()  : '';
    const email = emailEl ? emailEl.value.trim() : '';
    const phone = phoneEl ? phoneEl.value.trim() : '';

    if (!name || !email || !phone) return;

    const productEl = q('kp-wl-product');
    const msgEl     = q('kp-wl-msg');
    const product   = productEl ? productEl.value.trim() : '';
    const msg       = msgEl     ? msgEl.value.trim()     : '';
    const w         = WEEKENDS.find(function (x) { return x.id === state.waitlistId; });

    // Submit to Shopify contact form
    const body = [
      'form_type=contact',
      'utf8=✓',
      'contact[name]=' + encodeURIComponent(name),
      'contact[email]=' + encodeURIComponent(email),
      'contact[phone]=' + encodeURIComponent(phone),
      'contact[body]=' + encodeURIComponent(
        '[Waitlist] Weekend: ' + (w ? label(w) : state.waitlistId) +
        '\nProduct: ' + product +
        '\nMessage: ' + msg
      ),
      'contact[tags]=waitlist'
    ].join('&');

    fetch('/contact#contact_form', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body,
    }).finally(function () {
      showStep('waitlist-done');
    });
  }

  // ─── Photo upload ──────────────────────────────────────────────────────────

  function addPhotoThumb(file) {
    const row = q('kp-photos-row');
    const addBtn = q('kp-add-photo');
    if (!row || state.form.photos.length >= 5) return;

    state.form.photos.push(file);
    const idx = state.form.photos.length - 1;

    const thumb = el('div', 'kp-photo-thumb');
    const reader = new FileReader();
    reader.onload = function (e) {
      thumb.style.backgroundImage = 'url(' + e.target.result + ')';
      thumb.style.backgroundSize = 'cover';
      thumb.style.backgroundPosition = 'center';
    };
    reader.readAsDataURL(file);

    const removeBtn = el('button', 'kp-photo-thumb__remove', '✕');
    removeBtn.type = 'button';
    removeBtn.setAttribute('aria-label', 'Remove photo');
    removeBtn.addEventListener('click', function () {
      state.form.photos.splice(idx, 1);
      thumb.remove();
    });
    thumb.appendChild(removeBtn);
    row.insertBefore(thumb, addBtn);
  }

  // ─── Type button toggle ────────────────────────────────────────────────────

  function setBookingType(type) {
    state.bookingType = type;
    document.querySelectorAll('.kp-type-btn[data-type-btn]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.typeBtn === type);
    });
    renderWeekendList();
    renderCart();
  }

  // ─── URL param: pre-select weekend ─────────────────────────────────────────

  function checkUrlParams() {
    const params = new URLSearchParams(window.location.search);
    const weekendId = params.get('weekend');
    if (!weekendId) return;
    const w = WEEKENDS.find(function (x) { return x.id === weekendId; });
    if (!w) return;
    if (isSoldOut(w)) {
      openWaitlist(weekendId);
    } else {
      if (!state.cart.includes(weekendId)) state.cart.push(weekendId);
      renderWeekendList();
      renderCart();
    }
  }

  // ─── Event delegation ──────────────────────────────────────────────────────

  function handleClick(e) {
    const target = e.target;

    // data-action handlers
    const actionEl = target.closest('[data-action]');
    if (actionEl) {
      const action = actionEl.dataset.action;
      const weekendId = actionEl.dataset.weekendId;

      switch (action) {
        case 'to-details':
          toDetails();
          break;
        case 'to-select':
          showStep('select');
          break;
        case 'to-review':
          toReview();
          break;
        case 'pay-now':
          payNow();
          break;
        case 'join-waitlist':
          joinWaitlist();
          break;
        case 'add-photo':
          var inp = q('kp-photo-input');
          if (inp) inp.click();
          break;
        case 'toggle-weekend':
          if (weekendId) toggleWeekend(weekendId);
          break;
        case 'open-waitlist':
          if (weekendId) openWaitlist(weekendId);
          break;
        case 'remove-from-cart':
          if (weekendId) removeFromCart(weekendId);
          break;
      }
      return;
    }

    // Type buttons
    const typeBtn = target.closest('.kp-type-btn[data-type-btn]');
    if (typeBtn) {
      setBookingType(typeBtn.dataset.typeBtn);
      return;
    }
  }

  // ─── Init ──────────────────────────────────────────────────────────────────

  function init() {
    // Event delegation on document
    document.addEventListener('click', handleClick);

    // Photo file input
    const photoInput = q('kp-photo-input');
    if (photoInput) {
      photoInput.addEventListener('change', function (e) {
        Array.from(e.target.files).slice(0, 5 - state.form.photos.length).forEach(addPhotoThumb);
        e.target.value = '';
      });
    }

    // Home page weekend cards
    renderHomeWeekends();

    // Booking page setup
    if (q('kp-step-select')) {
      renderWeekendList();
      renderCart();
      checkUrlParams();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
